import type { Config } from 'config.types'

export const CSS_NAME = 'cvco'

export const userParticipantId = 'seamly-client-participant'

// How long to debounce distinct changes in unread messages for before
// broadcasting to the screen reader. This is done to avoid verbosity.
export const unreadScreenReaderWait = 2000

export const newMessageScreenReaderWait = 1000

export const screenReaderDebounceDelaySeconds = 10

export const activitySendDelay = 15000

export const maxCharacterWarningLimit = 50

export const maxCharacterSrDebounceDelay = 300

export const defaultTransitionTimeMs = 300

// How long to wait before we decide the user isn't typing
export const typingTimeout = 2000

export const defaultConfig: Partial<Config> = {
  namespace: 'default',
  layoutMode: 'window', // "window", "inline" ("sidebar")
  messages: {
    agent: {
      showAvatar: false, // true, "inline"
      showName: false,
    },
    user: {
      showAvatar: false, // true, "inline"
      showName: false,
    },
    timeIndicator: {
      enabled: false,
      threshold: 3600000, // Default threshold is an hour in milliseconds
    },
  },
}
